import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { CacheBustingService } from '../services/cache-busting.service';

export class CacheBustingTranslateLoader implements TranslateLoader {
  private readonly cacheBustingService: CacheBustingService;

  constructor(
    private readonly http: HttpClient,
    private readonly prefix = './assets/i18n/',
    private readonly suffix = '.json'
  ) {
    this.cacheBustingService = new CacheBustingService(http);
  }

  getTranslation(lang: string): Observable<any> {
    const url = this.cacheBustingService.getTranslationUrl(lang);
    return this.http.get(url);
  }
}

export function createCacheBustingTranslateLoader(http: HttpClient) {
  return new CacheBustingTranslateLoader(http, './assets/i18n/', '.json');
}
